import PropTypes from "prop-types";
import React from "react";
import XMLViewerDiv from "../../Inward/XmlViewer";
import Button from "../../../Button/Button";

const ShowXmlData = (props) => {
  const {
    nameEnquiry,
    fundTransfer,
    statusQuery,
    isRunningNE,
    isRunningFT,
    isRunningSQ,
    runNESuccess,
    runFTSuccess,
    runSQSuccess,
    error,
    closeBar,
    state,
    showAllLogs,
    test
  } = props;

  const anySuccess = runNESuccess || runFTSuccess || runSQSuccess;
  const noSuccess = !runNESuccess || !runFTSuccess || !runSQSuccess;
  return (
    <div>
      <div className="logs-area">
        {test.type === "name-enquiry" && (
          <XMLViewerDiv
            isLoading={isRunningNE}
            runSuccess={runNESuccess}
            request={nameEnquiry.request}
            response={nameEnquiry.response}
          />
        )}
        {test.type === "funds-transfer" && (
          <XMLViewerDiv
            isLoading={isRunningFT}
            runSuccess={runFTSuccess}
            request={fundTransfer.request}
            response={fundTransfer.response}
          />
        )}
        {test.type === "transfer-status-query" && (
          <XMLViewerDiv
            isLoading={isRunningSQ}
            runSuccess={runSQSuccess}
            request={statusQuery.request}
            response={statusQuery.response}
          />
        )}
      </div>
      {error &&
        <div className="error-subtitle2">
          {error && error.message}
        </div>
      }
      <br />
      <div className="flex-button">
        {!isRunningFT && !isRunningSQ && !isRunningNE && (
          <Button
            onClick={
              anySuccess && state.stepIndex === test.id && !error
                ? () => closeBar(test.id)
                : () => showAllLogs(test.id, test.type)
            }
            width="151px"
            height="50px"
            text={
              anySuccess && state.stepIndex === test.id && !error
                ? "PROCEED"
                : noSuccess && state.stepIndex === test.id && error
                  ? "RETRY"
                  : ""
            }
            testId="proceed"
            type="submit"
          />
        )}
      </div>
    </div>
  );
};

ShowXmlData.propTypes = {
  closeBar: PropTypes.func,
  error: PropTypes.any,
  fundTransfer: PropTypes.shape({
    request: PropTypes.any,
    response: PropTypes.any
  }),
  isRunningFT: PropTypes.any,
  isRunningNE: PropTypes.any,
  isRunningSQ: PropTypes.any,
  nameEnquiry: PropTypes.shape({
    request: PropTypes.any,
    response: PropTypes.any
  }),
  runFTSuccess: PropTypes.any,
  runNESuccess: PropTypes.any,
  runSQSuccess: PropTypes.any,
  showAllLogs: PropTypes.func,
  state: PropTypes.shape({
    stepIndex: PropTypes.any
  }),
  statusQuery: PropTypes.shape({
    request: PropTypes.any,
    response: PropTypes.any
  }),
  test: PropTypes.shape({
    id: PropTypes.any,
    type: PropTypes.string
  })
}

export default ShowXmlData;
